import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { api } from '@/lib/api';
import { useLanguage } from '@/contexts/LanguageContext';
import SEO, { articleSchema } from '@/components/SEO';
import { ArticleDetail } from '@/components/ArticleDetail';

const ArticleDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setArticle(null);
    api.getArticle(id).then(r => setArticle(r.data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-gray-500" data-testid="article-not-found">
        <p>{language === 'es' ? 'Artículo no encontrado' : language === 'de' ? 'Artikel nicht gefunden' : 'Article not found'}</p>
        <button onClick={() => navigate('/info')} className="text-[#38B2AC] underline">{language === 'es' ? 'Volver' : language === 'de' ? 'Zurück' : 'Back'}</button>
      </div>
    );
  }
  if (!article) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-[#38B2AC]" /></div>;
  }

  const title = article[`title_${language}`] || article.title_es;
  const description = article[`summary_${language}`] || article.summary_es || '';

  return (
    <>
      <SEO title={title} description={description} path={`/article/${article.id}`} lang={language} image={article.image} schema={articleSchema(article)} />
      <ArticleDetail article={article} onBack={() => (window.history.length > 1 ? navigate(-1) : navigate('/info'))} />
    </>
  );
};

export default ArticleDetailPage;
